import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-language-input-switcher',
  templateUrl: './language-input-switcher.component.html',
  styleUrls: ['./language-input-switcher.component.scss']
})
export class LanguageInputSwitcherComponent implements OnInit {
  @Input() selectedLanguage: string = "hr";
  @Input() defaultLanguage: string | undefined;
  @Output() languageSelected: EventEmitter<string> = new EventEmitter<string>();
  @Input() isHrFilled: boolean = false;
  @Input() isEnFilled: boolean = false;
  @Input() isItFilled: boolean = false;
  @Input() isSloFilled: boolean = false;
  @Input() isSrFilled: boolean = false;
  @Input() isBsFilled: boolean = false;

  @Input() isHrRequired: boolean = false;
  @Input() isEnRequired: boolean = false;
  @Input() isItRequired: boolean = false;
  @Input() isSloRequired: boolean = false;
  @Input() isSrRequired: boolean = false;
  @Input() isBsRequired: boolean = false;

  orderOfLanguages: string[] = ["hr", "en", "it", "slo", "sr", "bs"];
  languageIcons: { [key: string]: string } = {};

  ngOnInit() {
    this.initFields();
    this.initializeLanguageIcons();
  }

  initializeLanguageIcons() {
    this.languageIcons = {
      'hr': 'ioc-CRO',
      'en': 'ioc-GBR',
      'it': 'ioc-ITA',
      'slo': 'ioc-SLO',
      'sr': 'ioc-SRB',
      'bs': 'ioc-BIH'
    };
  }

  initFields() {
    if (this.selectedLanguage === undefined || this.selectedLanguage === '') {
      this.selectedLanguage = this.defaultLanguage ?? "hr";
    }
    this.orderOfLanguages = [this.defaultLanguage ?? "hr"].concat(this.orderOfLanguages.filter((lang: string) => lang !== (this.defaultLanguage ?? "hr")));
  }

  setLanguage(event: Event, language: string) {
    event.stopPropagation();
    this.languageSelected.emit(language);
    this.selectedLanguage = language;
  }
  getIsFilledValue(language: string): boolean {
    switch (language) {
      case "hr":
        return this.isHrFilled;
      case "en":
        return this.isEnFilled;
      case "it":
        return this.isItFilled;
      case "slo":
        return this.isSloFilled;
      case "sr":
        return this.isSrFilled;
      case "bs":
        return this.isBsFilled;
      default:
        return false;
    }
  }

  getIsRequiredValue(language: string): boolean {
    if (this.getIsFilledValue(language)) {
      return false;
    }
    else {
      switch (language) {
        case "hr":
          return this.isHrRequired;
        case "en":
          return this.isEnRequired;
        case "it":
          return this.isItRequired;
        case "slo":
          return this.isSloRequired;
        case "sr":
          return this.isSrRequired;
        case "bs":
          return this.isBsRequired;
        default:
          return false;
      }
    }
  }
}
